import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-10 px-4 pt-[10px] pb-[10px]" data-id="element-148">
      <div className="max-w-2xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-dark-card to-dark border border-dark-border rounded-2xl p-6 text-center relative overflow-hidden" data-id="element-150">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-brand to-transparent" data-id="element-151" />

          <h2 className="text-2xl md:text-3xl font-black mb-3" data-id="element-152">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-gray-300 mb-2" data-id="element-153">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en sesión.
          </p>
          <p className="text-lg font-bold text-brand mb-3" data-id="element-154">
            Si en 7 días no es lo que esperabas, te devolvemos el 100%.
          </p>

          <div className="inline-block bg-dark-border px-4 py-1.5 rounded-full text-sm text-gray-400 font-medium" data-id="element-155">
            +500 TOs confían · Tasa de devolución menor al 1%
          </div>
        </motion.div>
      </div>
    </section>;
}